<template>
  <div id="List3" class="scroller-wrapper scroll-vertical">
    <div id="Scroller">
      <div id="BannerContainer" @click="BannerClick()"
           v-if="Banners.length>0">
        <transition :enter-active-class="'slideIn'+BannerInDirecter"
                    :leave-active-class="'slideOut'+BannerOutDirecter">
          <img @touchstart="BannerTouchStart($event)"
               @touchend="BannerTouchEnd($event)"
               :key="thisBanner"
               class="animated"
               :src="require('../../assets/1st/Articles/Article_'+Banners[thisBanner-1]+'/lunbo.jpg')">
        </transition>
        <div id="BannerPointContainer" v-if="Banners.length>1"
             :style="BannerPointContainerStyle">
          <div v-for="p in Banners.length" class="BannerPoint" :class="{BannerPointSelect:thisBanner==p}"></div>
        </div>
      </div>
      <div id="ArticleContainer">
        <div class="ArticleBar" @click="viewArticle(a)"
             v-for="a in ThisList">
          <div class="ArticleIMG">
            <img :src="require('../../assets/1st/Articles/Article_'+a+'/cover.jpg')">
          </div>
          <div class="ArticleTitle">
            {{AllList[a].SecondTitle}}
<!--            {{AllList[a].title}}-->
<!--            文字待提供-->
          </div>
<!--          <div class="ArticleSecondTitle">-->
<!--            {{AllList[a].SecondTitle}}-->
<!--          </div>-->
          <div class="ArticleDate">
            {{AllList[a].date}}
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import store from '../../store/1st';
  export default {
    name: "List3",
    store,
    data(){
      return {
        scroller:0,
        AllList:[],
        Banners:[],
        touchVal:{x:0,y:0},
        BannerInDirecter:"Right",
        BannerOutDirecter:"Left",
        thisBanner:1,
        ThisList:[]
      }
    },
    mounted() {
      this.SetBannerPlay();
      this.AllList=this.$store.state.ArticleList
      this.ThisList=this.$store.state.List3
      var scrollerConfig = {
        '//Description' : 'Default scroller with no configuration'
      };

      this.scroller = new Scroller('#List3', scrollerConfig);
      this.Banners=this.$store.state.Banner3;
    },
    methods:{
      SetBannerPlay:function(){
        this.IntervalID=setInterval(()=> {
          this.NextBaner();
        },3000)
      },
      NextBaner:function(){
        this.BannerInDirecter="Right";
        this.BannerOutDirecter="Left";
        if(this.thisBanner==this.Banners.length) this.thisBanner=1;
        else this.thisBanner++
      },
      PreBaner:function(){
        this.BannerInDirecter="Left";
        this.BannerOutDirecter="Right";
        if(this.thisBanner==1) this.thisBanner=this.Banners.length;
        else this.thisBanner--
      },
      BannerTouchStart:function (e) {
        this.touchVal.x=e.touches[0].clientX
      },
      BannerTouchEnd:function (e) {
        let limit=this.$store.state.WindowSize.WindowWidth*0.15;
        if(e.changedTouches[0].clientX-this.touchVal.x>limit){
          clearInterval(this.IntervalID)
          this.PreBaner()
          this.SetBannerPlay()
        }
        if(e.changedTouches[0].clientX-this.touchVal.x<(-1*limit)){
          clearInterval(this.IntervalID)
          this.NextBaner()
          this.SetBannerPlay()
        }
      },
      viewArticle(id){
        this.$store.commit('PushArticle',id);
        this.$router.replace("/Article/"+id)
      },
      BannerClick(){
        let id=this.Banners[this.thisBanner-1]
        this.viewArticle(id);
      }
    },
    computed:{
      BannerPointContainerStyle(){
        return {
          width: 4.2*this.Banners.length+'rem',
          left:(112.5-(4.2*this.Banners.length))/2+'rem'
        }
      }
    }
  }
</script>

<style scoped>
  #List3{
    width: 100%;
    height: 100%;
    background: #f7f7f7;
  }
  #Scroller{
    width: 100%;
  }
  #BannerContainer{
    position: relative;
    width: 112.5rem;
    height: 63.4rem;
    overflow: hidden;
  }
  #BannerContainer img{
    position: absolute;
    width: 112.5rem;
  }
  #BannerPointContainer{
    position: absolute;
    height: 4.2rem;
    top:57.2rem;
  }
  .BannerPoint{
    width: 2rem;
    height: 2rem;
    border-radius: 1rem;
    margin: 1.1rem;
    background: #4136ff;
  }
  .BannerPointSelect{
    background: #ffffff;
  }

  #ArticleContainer{
    width: 100%;
    padding-bottom: 15rem;
  }
  .ArticleBar{
    width: 103.5rem;
    /*height: 62.7rem;*/
    height: 67.7rem;
    margin-left: 4.5rem;
    margin-top: 4.5rem;
    background: #fff;
    border-radius: 4.5rem;
    overflow: hidden;
    box-shadow: 0rem 0rem 2rem 0.1rem #ccc;
  }
  .ArticleIMG{
    width: 103.5rem;
    height: 43rem;
    overflow: hidden;
  }
  .ArticleIMG img{
    width: 100%;
  }
  .ArticleTitle{
    width: 94.5rem;
    /*height: 3.5rem;*/
    /*height: 8rem;*/
    height: 15rem;
    line-height: 3.8rem;
    font-size: 3.5rem;
    margin-left: 4.5rem;
    margin-right: 4.5rem;
    margin-top: 2rem;
    color: #989898;
    text-align: justify;
  }
  .ArticleSecondTitle{
    width: 94.5rem;
    height: 2.5rem;
    line-height: 2.5rem;
    font-size: 2.5rem;
    margin-left: 4.5rem;
    margin-right: 4.5rem;
    margin-top: 2rem;
    color: #989898;
  }
  .ArticleDate{
    width: 94.5rem;
    height: 2rem;
    line-height: 2rem;
    font-size: 2rem;
    margin-left: 4.5rem;
    margin-right: 4.5rem;
    margin-top: 2.5rem;
    margin-bottom: 2.5rem;
    color: #989898;
  }
</style>



// WEBPACK FOOTER //
// src/components/1st/List3.vue